import { useEffect, useState } from "react";
import api from "../../lib/api";
import AdminHeader from "../../components/admin/AdminHeader";

export default function AdminGenerations() {
  const [g, setG] = useState([]);

  useEffect(() => { api.get("/admin/yard-generations").then((r) => setG(r.data || [])); }, []);

  const today = new Date().toISOString().slice(0, 10);
  const todayCount = g.filter((x) => (x.created_at || "") >= today).length;
  const uniqueEmails = new Set(g.map((x) => x.email)).size;
  const estSpend = (g.length * 0.18).toFixed(2);

  return (
    <div data-testid="admin-generations">
      <AdminHeader title="AI Designs" subtitle="Lead-gated AI yard designer submissions." count={g.length} />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {[
          ["Total", g.length],
          ["Unique Emails", uniqueEmails],
          ["Est. Spend (CAD)", `$${estSpend}`],
          ["Today", todayCount],
        ].map(([label, val]) => (
          <div key={label} className="bg-[#151515] border border-[#D8D6D0]/10 p-5">
            <div className="overline text-[10px] text-[#D8D6D0]/50">{label}</div>
            <div className="font-serif-display text-3xl mt-1">{val}</div>
          </div>
        ))}
      </div>

      <div className="space-y-3">
        {g.length === 0 && (
          <div className="text-sm text-[#D8D6D0]/50 bg-[#151515] border border-[#D8D6D0]/10 p-8 text-center">
            No AI generations yet.
          </div>
        )}
        {g.map((x) => (
          <div key={x.id} data-testid={`gen-row-${x.id}`} className="bg-[#151515] border border-[#D8D6D0]/10 p-5 grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
            <div className="md:col-span-3">
              <div className="font-serif-display text-base">{x.name}</div>
              <div className="text-xs text-[#D8D6D0]/55 mt-1">{x.email}</div>
              <div className="text-xs text-[#D8D6D0]/45 mt-0.5">{x.phone}</div>
            </div>
            <div className="md:col-span-4 text-xs text-[#D8D6D0]/80 space-y-0.5">
              <div><span className="text-[#D8D6D0]/40">Size:</span> {x.form?.width_ft} × {x.form?.depth_ft} ft</div>
              <div><span className="text-[#D8D6D0]/40">Budget:</span> {x.form?.budget}</div>
              <div><span className="text-[#D8D6D0]/40">Style:</span> {x.form?.style}</div>
            </div>
            <div className="md:col-span-3 text-[11px] text-[#D8D6D0]/50">
              {x.form?.features?.slice(0, 4).join(", ")}{x.form?.features?.length > 4 ? "…" : ""}
              <div className="mt-1 text-[#D8D6D0]/35">IP: {x.ip || "—"}</div>
            </div>
            <div className="md:col-span-2 text-[11px] text-[#D8D6D0]/45 text-right">
              {new Date(x.created_at).toLocaleString()}
              <div className="mt-1">{x.concepts?.length || 0} concepts</div>
              {x.selected_concept_label && (
                <div className="mt-2 inline-flex items-center gap-1.5 px-2 py-1 bg-[#8C1D30] text-[#F5F3EF] text-[10px] uppercase tracking-widest">
                  Picked {x.selected_concept_label}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
